import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        deleteMovement(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/movements/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
}